/**
 * Hooks for the email-verification flow (Module 2.1 Phase 1 P2).
 *
 * Both wrap the corresponding backend endpoint shipped in Phase 2 P2.
 * useVerifyEmail is fired from the /verify-email landing page when a
 * token is in the URL. useResendVerification powers the "Send a new
 * link" buttons on the pending page and (later, P3) on the
 * unverified-email banner.
 */
import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
  authApi,
  type ResendVerificationResponse,
  type VerifyEmailResponse,
} from '@/api/auth'


export function useVerifyEmail() {
  const qc = useQueryClient()
  return useMutation<VerifyEmailResponse, unknown, string>({
    mutationFn: (token: string) => authApi.verifyEmail({ token }),
    onSuccess: () => {
      // The backend's /me response now reads is_verified=true; nudge
      // any cached copy so the unverified-email banner disappears
      // without a hard reload.
      qc.invalidateQueries({ queryKey: ['auth', 'me'] })
    },
  })
}


export function useResendVerification() {
  return useMutation<ResendVerificationResponse, unknown, void>({
    mutationFn: () => authApi.resendVerification(),
  })
}
